import { c as _c } from "react/compiler-runtime";
import { NavigationHeader } from '@/idv/components';
import DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageUploadError, ReceivedImagePayload } from '../../../types';
import { useNonIdDocMachine } from '../../components/machine-provider';
import useDocName from '../../hooks/use-doc-name';
const DesktopRetry = () => {
  const $ = _c(18);
  const [state, send] = useNonIdDocMachine();
  const {
    requirement,
    errors,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const docName = useDocName(requirement.config);
  let t0;
  if ($[0] !== send) {
    t0 = () => send({
      type: "navigatedToPrompt"
    });
    $[0] = send;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClickBack = t0;
  let t1;
  if ($[2] !== send) {
    t1 = payload => send({
      type: "receivedDocument",
      payload
    });
    $[2] = send;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleComplete = t1;
  let t2;
  if ($[4] !== send) {
    t2 = errs => {
      send({
        type: "uploadErrored",
        payload: {
          errors: errs.map(_temp)
        }
      });
    };
    $[4] = send;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleUploadError = t2;
  let t3;
  if ($[6] !== handleClickBack) {
    t3 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: handleClickBack
    }} />;
    $[6] = handleClickBack;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== allowPdf || $[9] !== docName || $[10] !== errors || $[11] !== handleComplete || $[12] !== handleUploadError || $[13] !== hasBadConnectivity) {
    t4 = <DesktopPhotoPrompt docName={docName} isRetry={true} errors={errors} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onUploadSuccess={handleComplete} onUploadError={handleUploadError} />;
    $[8] = allowPdf;
    $[9] = docName;
    $[10] = errors;
    $[11] = handleComplete;
    $[12] = handleUploadError;
    $[13] = hasBadConnectivity;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default DesktopRetry;
function _temp(err) {
  return {
    errorType: err
  };
}